module.exports = __webpack_public_path__ + "files/ba6c2bb5a8b45269bd39acd935beeaf6.png";